import UltMeta, { Meta } from "./UltMeta/index";
// 发票抬头

class HeaderType extends UltMeta {
    PERSONAL = new Meta(1, "企业");
    COMPANY = new Meta(2, "个人或事业单位");
}

export const HEADER_TYPE = new HeaderType();

class InvoiceType extends UltMeta {
    PERSONAL = new Meta(1, "普通发票");
    COMPANY = new Meta(2, "增值税专用发票");
}

export const INVOICE_TYPE = new InvoiceType();


class InvoiceHeaderType extends UltMeta {
    PERSONAL = new Meta(1, "普通发票");
    COMPANY = new Meta(2, "增值税发票");
}
export const INVOICE_HEADER_TYPE = new InvoiceHeaderType();